import { render } from "./WidgetTitle.vue?vue&type=template&id=4a7962d4&scoped=true"
import script from "./WidgetTitle.vue?vue&type=script&lang=js"
export * from "./WidgetTitle.vue?vue&type=script&lang=js"

import "./WidgetTitle.vue?vue&type=style&index=0&id=4a7962d4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a7962d4"]])

export default __exports__